<template>
    <div class="loader" v-if="isActive">
        <div class="loader__logo"></div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            // attach event listeners
            eventBus.$on('hide-loader', this.hideLoader);
            eventBus.$on('show-loader', this.showLoader);
        },
        data: function () {
            return {
                isActive: 0
            }
        },
        destroyed: function () {
            // detach event listeners
            eventBus.$off('hide-loader', this.hideLoader);
            eventBus.$off('show-loader', this.showLoader);
        },
        methods: {
            hideLoader: function () {
                this.isActive--;

                if (this.isActive < 0) {
                    this.isActive = 0;
                }
            },
            showLoader: function () {
                this.isActive++;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/Loader.vue